import type {IconType} from "react-icons";
import {MdDashboard} from "react-icons/md";
import {FaQuoteLeft} from "react-icons/fa6";
import {SiMagento} from "react-icons/si";

export interface NavigationItem {
  title: string;
  icon: string | IconType;
  color: string;
  url?: string;
  isComingSoon?: boolean;
  onClick?: () => void;
}

export const navigationItems: NavigationItem[] = [
  {
    title: "Dashboard",
    icon: MdDashboard,
    color: "fill-brandPurple-300",
    url: "/",
  },
  {
    title: "Glix AI",
    icon: SiMagento,
    color: "fill-brandPurple-300",
    isComingSoon: true,
    onClick: () => alert("Glix AI Search Activated!")
  },
  {
    title: "Manage subscription",
    icon: "card",
    color: "fill-brandPurple-300",
    url: "/pricing",
    isComingSoon: true,
  },
  {
    title: "Updates & Faq",
    icon: FaQuoteLeft,
    color: "fill-brandPurple-300",
    url: "/updates-and-faq",
    isComingSoon: false,
  }
];

